import * as React from 'react';

const SvgLongArrow = props => (
  <svg
    height={30.782}
    viewBox="0 0 95.043 30.782"
    width={95.043}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      data-name="Group 1764"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        d="M0 15.39h94.174"
        data-name="Path 19"
      />
      <path
        d="M78.946.707 93.63 15.391 78.946 30.075"
        data-name="Path 20"
      />
    </g>
  </svg>
);

export default SvgLongArrow;

